import { render, staticRenderFns } from "./ReqCompraComponent.vue?vue&type=template&id=769abd0e&"
import script from "./ReqCompraComponent.vue?vue&type=script&lang=js&"
export * from "./ReqCompraComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports